import React, { useCallback, useEffect, useState } from 'react';

export enum ScreenSize {
  Mobile = 'mobile',
  Tablet = 'tablet',
  Standard = 'standard',
  Large = 'large',
}

const defaultContext = {
  screenSize: ScreenSize.Standard,
  width: window.innerWidth,
  siteOffsetTop: 0,
};

export const ResponsiveContext = React.createContext(defaultContext);

interface Props {
  children?: React.ReactNode;
}

const Responsive: React.FunctionComponent<Props> = ({ children }) => {
  const [responsiveState, setResponsiveState] = useState(defaultContext);

  const handler = useCallback(() => {
    const width = window.innerWidth;
    let screenSize = ScreenSize.Large;
    if (width < 768) {
      screenSize = ScreenSize.Mobile;
    } else if (width < 1024) {
      screenSize = ScreenSize.Tablet;
    } else if (width < 1366) {
      screenSize = ScreenSize.Standard;
    }
    const siteOffsetTop =
      (document.querySelector('#site') as HTMLElement | null)?.offsetTop || 0;

    setResponsiveState({
      screenSize,
      width,
      siteOffsetTop,
    });
  }, []);

  useEffect(() => {
    handler(); // for initial load
    window.addEventListener('resize', handler);
    return () => {
      window.removeEventListener('resize', handler);
    };
  }, [handler]);

  return (
    <ResponsiveContext.Provider value={responsiveState}>
      {children}
    </ResponsiveContext.Provider>
  );
};

export default Responsive;
